// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-message {\n  font: 12px/150% \"proxima nova\", sans-serif;\n  bottom: 0;\n  left: 0;\n  color: #fd8080;\n  margin: 4px 0;\n  width: 100% !important; }\n", ""]);
// Exports
module.exports = exports;
